import { BidPack, bidPackObjectName, defaultBidPack } from "../BidPack";
import { toBidPackWriteRequest } from "../BidPackWriteRequest";
import { useAddBidPack } from "../Hooks/useAddBidPack";
import { BidPackFormTabs } from "./BidPackFormTabs";

export const AddBidPack = () => {
  const { mutate: addBidPack } = useAddBidPack();

  return (
    <BidPackFormTabs
      title={`Add ${bidPackObjectName}`}
      bidPack={defaultBidPack}
      onSave={(bidPack: BidPack) => addBidPack(toBidPackWriteRequest(bidPack))}
    />
  );
};
